import React, { useState } from "react";
import "../Aboutus/Aboutus.css";
import Three from "../Three/Three";
import Abouttext from "./About-text";
import TestimonialSlider from "../Testimonials/Testimonials";
import WhyClientsChooseUs from "../Why/Why";
import Abteam from "./Abteam";
import Newsletter from "../Newsletter/Newsletter";
import MissionVision from "./Mission";

const AboutUs = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>
      <div className="about-us-ab">
        {/* Top Section */}
        <div className="top-section-ab">
          <div className="thumbnail-container-ab">
            <img src="/lawyer.webp" alt="thumbnail" className="thumbnail-ab" />
            <button
              className="play-button-ab"
              onClick={() => setShowVideo(true)}
            >
              ▶
            </button>
            {showVideo && (
              <div className="video-popup-ab">
                <div className="video-content-ab">
                  <span
                    className="close-ab"
                    onClick={() => setShowVideo(false)}
                  >
                    &times;
                  </span>
                  <iframe
                    width="100%"
                    height="400"
                    src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                    title="Video"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            )}
          </div>

          <div className="about-content-ab">
            <p className="about-tag-ab">ABOUT LAWYER FIRM</p>
            <h1 className="about-heading-ab">Our Gorgeous History</h1>
            <p className="about-text-ab">
              One morning, when Megan Pauler woke from troubled dreams, he found
              himself transformed in his bed into a horrible vermin. He lay on
              his armour-like back, and if he lifted his head a little he could
              see his brown belly, slightly domed and divided by arches into
              stiff sections. The bedding was hardly able to cover it...
            </p>
            <img src="/sign.webp" alt="signature" className="signature-ab" />
            <p className="post-name-ab">
              Name
              <br />
              CEO & FOUNDER OF LAWYER FIRM
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="bottom-section-ab">
          <div className="skills-section-ab">
            <h1 className="skills-heading-ab">Firm’s Skills</h1>
            <p className="skills-text-ab">
              One morning, when Megan Pauler woke from troubled dreams, he found
              himself transformed in his bed into...
            </p>
            <div className="progress-bar-ab">
              <label>Practice Area</label>
              <div className="bar-ab">
                <div className="fill-ab" style={{ width: "80%" }}></div>
              </div>
            </div>
            <div className="progress-bar-ab">
              <label>Happy Customer</label>
              <div className="bar-ab">
                <div className="fill-ab" style={{ width: "100%" }}></div>
              </div>
            </div>
            <div className="progress-bar-ab">
              <label>Firm Size</label>
              <div className="bar-ab">
                <div className="fill-ab" style={{ width: "70%" }}></div>
              </div>
            </div>
            <div className="progress-bar-ab">
              <label>Success Case</label>
              <div className="bar-ab">
                <div className="fill-ab" style={{ width: "90%" }}></div>
              </div>
            </div>
          </div>

          <div className="image-right-ab">
            <img src="/book.webp" alt="library" className="full-image-ab" />
          </div>
        </div>
      </div>

      <MissionVision />
      <Abouttext />
      <Three />
      <Abteam />
      <Newsletter />
    </>
  );
};

export default AboutUs;
